<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <img class="ctn-image animate-target" v-animate-in src="../../assets/images/p3-5/3-5.png" />
    <GoNext class="animate-target" v-animate-in href="/section3/3-6">Next</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
export default {
  name: "s3-5",
  components: {SectionTitle, GoNext, ContentNotice},
  data(){
    return {
      noticeTxt:"CKD, chronic kidney disease; CV, cardiovascular; DKD, diabetic kidney disease;  eGR, estimated glomerular filtration rate; RAS, T2D, type 2 diabetes; UACR, urine albumin-to-creatinine ratio.<br/><div class='brs'></div>"
      +"References:<br/><div class='brs'></div>"
      +"1. Agarwal R, <i>et al. Eur Heart J</i> 2022;43:474–484;<br/>"
      +"2. Bakris GL, <i>et al. N Engl J Med</i> 2020;383:2219-2229;<br/>"
      +"3. Pitt B, <i>et al. N Engl J Med</i> 2021;385:2252-2263.",
      title:'FIDELIO-DKD and FIGARO-DKD assessed prespecified kidney outcomes in people across the spectrum of CKD severity'
    };
  },
  methods:{

  }
}
</script>

<style scoped>
@import "../../assets/css/section3/s3.css";
.ctn-image {
  width: 100%;
  margin-top: 40px;
}
</style>
